import { render, staticRenderFns } from "./loginSingle.vue?vue&type=template&id=7aa472f0&"
import script from "./loginSingle.vue?vue&type=script&lang=js&"
export * from "./loginSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports